import styled from 'styled-components'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2em;
  text-align: center;
`

export default Content
